import React, {type ReactNode, useState} from "react";
import {User} from "@/data/entities/user";
import {AuthStateContext} from "./use-auth-state";


type Props = {
    initialUser: User | null;
    children: ReactNode;
};

export const AuthStateProvider = ({initialUser, children}: Props) => {
    const [user, setUser] = useState<User | null>(initialUser);

    return (
        <AuthStateContext.Provider
            value={{
                user,
                setUser,
            }}
        >
            {children}
        </AuthStateContext.Provider>
    );
};
